import {
  HrLeaveEntitlement,
  IPatchLeaveEntitlementsPayload,
  IPostLeaveEntitlementPayload,
  TGetLeaveEntitlementsPayload,
} from "app/models/hrLeaveEntitlement"

export enum Types {
  GET = "HR_LEAVE_ENTITLEMENT_GET",
  GET_SUCCESS = "HR_LEAVE_ENTITLEMENT_GET_SUCCESS",
  GET_FAIL = "HR_LEAVE_ENTITLEMENT_GET_FAIL",
  POST = "HR_LEAVE_ENTITLEMENT_POST",
  POST_SUCCESS = "HR_GLEAVE_ENTITLEMENT_POST_SUCCESS",
  POST_FAIL = "HR_LEAVE_ENTITLEMENT_POST_FAIL",
  PATCH = "HR_LEAVE_ENTITLEMENT_PATCH",
  PATCH_SUCCESS = "HR_LEAVE_ENTITLEMENT_PATCH_SUCCESS",
  PATCH_FAIL = "HR_LEAVE_ENTITLEMENT_PATCH_FAIL",
  DELETE = "HR_LEAVE_ENTITLEMENT_DELETE",
  DELETE_SUCCESS = "HR_LEAVE_ENTITLEMENT_DELETE_SUCCESS",
  DELETE_FAIL = "HR_LEAVE_ENTITLEMENT_DELETE_FAIL",
}

export type Action =
  | GetHrLeaveEntitlementsAction
  | GetHrLeaveEntitlementsSuccessAction
  | GetHrLeaveEntitlementsFailAction
  | PostHrLeaveEntitlementsAction
  | PostHrLeaveEntitlementsSuccessAction
  | PostHrLeaveEntitlementsFailAction
  | PatchHrLeaveEntitlementsAction
  | PatchHrLeaveEntitlementsSuccessAction
  | PatchHrLeaveEntitlementsFailAction
  | DeleteHrLeaveEntitlementsAction
  | DeleteHrLeaveEntitlementsSuccessAction
  | DeleteHrLeaveEntitlementsFailAction

export type GetHrLeaveEntitlementsAction = {
  payload: TGetLeaveEntitlementsPayload
  type: Types.GET
}

export type GetHrLeaveEntitlementsSuccessAction = {
  payload: { hrLeaveEntitlements: HrLeaveEntitlement[] }
  type: Types.GET_SUCCESS
}

export type GetHrLeaveEntitlementsFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PostHrLeaveEntitlementsAction = {
  payload: { hrLeaveEntitlement: IPostLeaveEntitlementPayload; year: number }
  type: Types.POST
}

export type PostHrLeaveEntitlementsSuccessAction = {
  payload: { hrLeaveEntitlement: HrLeaveEntitlement }
  type: Types.POST_SUCCESS
}

export type PostHrLeaveEntitlementsFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export type PatchHrLeaveEntitlementsAction = {
  payload: { hrLeaveEntitlement: IPatchLeaveEntitlementsPayload; id: number; year: number }
  type: Types.PATCH
}

export type PatchHrLeaveEntitlementsSuccessAction = {
  payload: { hrLeaveEntitlement: HrLeaveEntitlement }
  type: Types.PATCH_SUCCESS
}

export type PatchHrLeaveEntitlementsFailAction = {
  payload: { errors: object }
  type: Types.PATCH_FAIL
}

export type DeleteHrLeaveEntitlementsAction = {
  payload: { hrLeaveEntitlementId: number; employee_id: string; year: number }
  type: Types.DELETE
}

export type DeleteHrLeaveEntitlementsSuccessAction = {
  payload: { hrLeaveEntitlement: HrLeaveEntitlement }
  type: Types.DELETE_SUCCESS
}

export type DeleteHrLeaveEntitlementsFailAction = {
  payload: { errors: object }
  type: Types.DELETE_FAIL
}

export function getHrLeaveEntitlements(payload: TGetLeaveEntitlementsPayload): GetHrLeaveEntitlementsAction {
  return {
    payload,
    type: Types.GET,
  }
}

export function getHrLeaveEntitlementsSuccess(
  hrLeaveEntitlements: HrLeaveEntitlement[],
): GetHrLeaveEntitlementsSuccessAction {
  return {
    payload: { hrLeaveEntitlements },
    type: Types.GET_SUCCESS,
  }
}

export function getHrLeaveEntitlementsFail(errors: object): GetHrLeaveEntitlementsFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function postHrLeaveEntitlement(payload: {
  hrLeaveEntitlement: IPostLeaveEntitlementPayload
  year: number
}): PostHrLeaveEntitlementsAction {
  return {
    payload,
    type: Types.POST,
  }
}

export function postHrLeaveEntitlementSuccess(
  hrLeaveEntitlement: HrLeaveEntitlement,
): PostHrLeaveEntitlementsSuccessAction {
  return {
    payload: { hrLeaveEntitlement },
    type: Types.POST_SUCCESS,
  }
}

export function postHrLeaveEntitlementFail(errors: object): PostHrLeaveEntitlementsFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}

export function patchHrLeaveEntitlement(payload: {
  hrLeaveEntitlement: IPatchLeaveEntitlementsPayload
  id: number
  year: number
}): PatchHrLeaveEntitlementsAction {
  return {
    payload,
    type: Types.PATCH,
  }
}

export function patchHrLeaveEntitlementSuccess(
  hrLeaveEntitlement: HrLeaveEntitlement,
): PatchHrLeaveEntitlementsSuccessAction {
  return {
    payload: { hrLeaveEntitlement },
    type: Types.PATCH_SUCCESS,
  }
}

export function patchHrLeaveEntitlementFail(errors: object): PatchHrLeaveEntitlementsFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_FAIL,
  }
}

export function deleteHrLeaveEntitlementLeave(payload: {
  hrLeaveEntitlementId: number
  employee_id: string
  year: number
}): DeleteHrLeaveEntitlementsAction {
  return {
    payload,
    type: Types.DELETE,
  }
}

export function deleteHrLeaveEntitlementSuccess(
  hrLeaveEntitlement: HrLeaveEntitlement,
): DeleteHrLeaveEntitlementsSuccessAction {
  return {
    payload: { hrLeaveEntitlement },
    type: Types.DELETE_SUCCESS,
  }
}

export function deleteHrLeaveEntitlementFail(errors: object): DeleteHrLeaveEntitlementsFailAction {
  return {
    payload: { errors },
    type: Types.DELETE_FAIL,
  }
}
